import * as constants from './constants';

const initialState = {
  loading: false,
  data: null,
  error: null,
  selectedImageIds: [],
  selectedItemIds: [],
  selectedSetIds: [],
  selectedColorIds: [],
};

// eslint-disable-next-line import/prefer-default-export
export const projectReducer = (state = initialState, action) => {
  switch (action.type) {
  case constants.GET_PROJECT:
  case constants.DELETE_PROJECT:
  case constants.CREATE_PROJECT:
  case constants.DELETE_PROJECTS:
    return { ...state, loading: true };
  case constants.SELECT_PROJECT_DETAILS_ITEM:
    return { ...state, selectedItemIds: [...state.selectedItemIds, action.payload.id] };
  case constants.SELECT_PROJECT_DETAILS_IMAGE:
    return { ...state, selectedImageIds: [...state.selectedImageIds, action.payload.id] };
  case constants.SELECT_PROJECT_DETAILS_SET:
    return { ...state, selectedSetIds: [...state.selectedSetIds, action.payload.id] };
  case constants.SELECT_PROJECT_DETAILS_COLOR:
    return { ...state, selectedColorIds: [...state.selectedColorIds, action.payload.id] };
  case constants.DESELECT_PROJECT_DETAILS_ITEM:
    return { ...state, selectedItemIds: state.selectedItemIds.filter((id) => id !== action.payload.id) };
  case constants.DESELECT_PROJECT_DETAILS_IMAGE:
    return { ...state, selectedImageIds: state.selectedImageIds.filter((id) => id !== action.payload.id) };
  case constants.DESELECT_PROJECT_DETAILS_SET:
    return { ...state, selectedSetIds: state.selectedSetIds.filter((id) => id !== action.payload.id) };
  case constants.DESELECT_PROJECT_DETAILS_COLOR:
    return { ...state, selectedColorIds: state.selectedColorIds.filter((id) => id !== action.payload.id) };
  case constants.RESET_PROJECT_DETAILS_COLOR:
    return { ...state, selectedColorIds: [] };
  case constants.RESET_PROJECT_DETAILS_SET:
    return { ...state, selectedSetIds: [] };
  case constants.RESET_PROJECT_DETAILS_IMAGE:
    return { ...state, selectedImageIds: [] };
  case constants.RESET_PROJECT_DETAILS_ITEM:
    return { ...state, selectedItemIds: [] };
  case constants.GET_PROJECT_SUCCESS:
    return { ...state, loading: false, data: action.payload };
  case constants.GET_PROJECT_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.CREATE_PROJECT_SUCCESS:
  case constants.DELETE_PROJECTS_SUCCESS:
  case constants.DELETE_PROJECT_SUCCESS:
    return { ...state, loading: false };
  case constants.DELETE_PROJECTS_ERROR:
  case constants.CREATE_PROJECT_ERROR:
  case constants.DELETE_PROJECT_ERROR:
    return { ...state, loading: false, error: action.payload };
  case constants.RESET_PROJECT_ENTITY_DATA:
    return {
      ...state,
      loading: false,
      error: null,
      data: null,
    };
  case constants.RESET_PROJECT:
    return initialState;
  default:
    return state;
  }
};
